export const TABLE_TYPES = {
  RAW: 'RAW',
  BOM: 'BOM',
} as const;
export const MINIMUM_CONFIDENCE = 70;

export const DEFAULT_ROOT_PART_NUMBER = 'ROOT';

export const NoBomReasons = {
  MISSING_KEY_COLUMNS: {
    title: 'Missing key BOM columns',
    description:
      'BOMs are found by looking for column headers that contain keywords that represent an identifier (part number or description) and quantity.',
  },
  MISSING_OR_INVALID_QUANTITIES: {
    title: 'Missing or invalid item quantities',
    description:
      'All rows must have a whole number in the quantity column. Tables with multiple quantity columns are not currently supported for BOM interpretation.',
  },
  INCONSISTENT_PART_NUMBERS: {
    title: 'Inconsistent part identifiers',
    description:
      'The identifier column (part number) must be filled for all rows.',
  },
  INCONSISTENT_PART_DESCRIPTIONS: {
    title: 'Inconsistent part descriptions',
    description:
      'The identifier column (description) must be filled for all rows.',
  },
};
